import React from "react";
import HistoryModal from "./historyModal";
import DownloadSampleFile from "./dwonloadSample";
import UploadFile from "./uploadFiles";
import EmailForm from "./emailForm";
import "../report-styles/uploadModule.scss";

const UploadModule = ({ upload, index, historyData, eMail, customIndex }) => {
  const isSampleFileDownloadable = upload.isDownlaodDisabled ? false : true;
  return (
    <div
      className={true ? "individual-report" : "individual-report disabled"}
      style={{ margin: upload.tag ? "10px 0px" : "10px 32px" }}
      key={upload.title}
    >
      <div className="report-index">
        {customIndex ?? String(index + 1).padStart(2, "0")}
      </div>
      <h4>
        {upload.title}
        {/* <button onClick={this.toggleDrawer}>→</button> */}
      </h4>
      {/* {upload.variants && upload.variants.length > 0 && (
        <VariantsContainer variants={upload.variants} />
      )} */}
      <div className="upload-icon-container">
        {historyData.length > 0 && (
          <HistoryModal
            uploadConfig={upload}
            historyData={historyData.filter(
              (i) => i.file_tag === upload.file_tag,
            )}
          />
        )}
        {isSampleFileDownloadable && (
          <DownloadSampleFile uploadConfig={upload} />
        )}
        {upload.isEmailRequired ? (
          <EmailForm upload={upload} />
        ) : (
          <UploadFile
            heading={upload.title}
            api={upload.api}
            help={upload.helpText ? upload.helpText : null}
            varients={upload.varients || []}
            eMail={eMail}
            tag={upload.tag ?? null}
            feedbackResponse={upload.feedbackResponse}
          />
        )}
      </div>
    </div>
  );
};

export default UploadModule;
